import PropTypes from 'prop-types';
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import * as utils from '../date_utils';
import MonthDropdownOptions from '../month_dropdown_options';
const WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
export default class MonthDropdown extends React.Component {
    state = {
        dropdownVisible: false
    };
    renderSelectOptions = (monthNames)=>monthNames.map((M, i)=>/*#__PURE__*/ React.createElement("option", {
                key: i,
                value: i
            }, M));
    renderSelectMode = (monthNames)=>/*#__PURE__*/ React.createElement("select", {
            value: this.props.month,
            className: "react-datepicker__month-select",
            onChange: (e)=>this.onChange(e.target.value)
        }, this.renderSelectOptions(monthNames));
    renderReadView = (visible, monthNames)=>/*#__PURE__*/ React.createElement("div", {
            key: "read",
            style: {
                visibility: visible ? 'visible' : 'hidden'
            },
            className: "react-datepicker__month-read-view",
            onClick: this.toggleDropdown
        }, /*#__PURE__*/ React.createElement("span", {
            className: "react-datepicker__month-read-view--down-arrow"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "react-datepicker__month-read-view--selected-month"
        }, monthNames[this.props.month]));
    renderDropdown = (monthNames)=>/*#__PURE__*/ React.createElement(WrappedMonthDropdownOptions, {
            key: "dropdown",
            ref: "options",
            month: this.props.month,
            monthNames: monthNames,
            onChange: this.onChange,
            onCancel: this.toggleDropdown
        });
    renderScrollMode = (monthNames)=>{
        const { dropdownVisible } = this.state;
        const result = [
            this.renderReadView(!dropdownVisible, monthNames)
        ];
        if (dropdownVisible) {
            result.unshift(this.renderDropdown(monthNames));
        }
        return result;
    };
    onChange = (month)=>{
        this.toggleDropdown();
        if (month !== this.props.month) {
            this.props.onChange(month);
        }
    };
    toggleDropdown = ()=>this.setState({
            dropdownVisible: !this.state.dropdownVisible
        });
    render() {
        const localeData = utils.getLocaleDataForLocale(this.props.locale);
        const monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? (M)=>utils.getMonthShortInLocale(localeData, utils.newDate({
                M
            })) : (M)=>utils.getMonthInLocale(localeData, utils.newDate({
                M
            }), this.props.dateFormat));
        let renderedDropdown;
        switch(this.props.dropdownMode){
            case 'scroll':
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case 'select':
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: `react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--${this.props.dropdownMode}`
        }, renderedDropdown);
    }
}
MonthDropdown.propTypes = {
    dateFormat: PropTypes.string.isRequired,
    dropdownMode: PropTypes.oneOf([
        'scroll',
        'select'
    ]).isRequired,
    locale: PropTypes.string,
    month: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    useShortMonthInDropdown: PropTypes.bool
};
